import type { personMachine } from '~domains/profile/entities/person';

import type { SnapshotFrom } from 'xstate';

import { PROFILE_NAV_STEPS, ProfileNavStepId } from './profile-nav-steps';

type PersonState = SnapshotFrom<typeof personMachine>;

const PROFILE_STEP_IDS: ReadonlySet<string> = new Set(
  Object.values(PROFILE_NAV_STEPS)
);

const isProfileNavStepId = (value: string): value is ProfileNavStepId =>
  PROFILE_STEP_IDS.has(value);

export const getActiveProfileNavStepId = (
  state: PersonState
): ProfileNavStepId | undefined => {
  const { value } = state;

  return typeof value === 'string' && isProfileNavStepId(value)
    ? value
    : undefined;
};
